import "./src/sass/global.scss";

export const onRouteUpdate = ({ location }) => {
  // Google Analytics
  if (typeof window.gtag === "function") {
    window.gtag("config", "G-E52Z2DZ5BR", {
      page_path: location.pathname + location.search + location.hash,
    });
  }

  // Facebook Pixel
  if (typeof window.fbq === "function") {
    window.fbq("track", "PageView");
  }
};
